import * as React from 'react';

import { cn } from '../../libraries/tailwind/utils';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const Input = React.forwardRef(({ className, type, autoComplete = 'on', namespace, entity, value, placeholderWidth = null, ...props }, ref) => {
  const { t: translate } = useTranslation();

  const placeholder = namespace && entity ? translate(entity, { ns: namespace }) : '';

  const baseStyle = cn(
    'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background',
    'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground',
    'focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-300',
    'invalid:border-danger focus:invalid:border-danger focus:invalid:ring-danger',
    className
  );


  if (type === 'textarea') {
    return (
      <textarea
        value={value}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className={cn(baseStyle, 'min-h-20 resize-none')}
        ref={ref}
        {...props}
      />
    );
  }

  return (
    (<input
      value={value}
      type={type}
      autoComplete={autoComplete}
      placeholder={placeholder}
      className={baseStyle}
      ref={ref}
      style={{ width: placeholderWidth && `${placeholderWidth}px` }}
      {...props} />)
  );
});

Input.displayName = 'Input';

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  autoComplete: PropTypes.string,
  namespace: PropTypes.string,
  entity: PropTypes.string,
  value: PropTypes.any
};

export { Input };
